import React from 'react';
import { useResizeDetector } from 'react-resize-detector';
import styled from 'styled-components';
import {
  animated,
  useSpring,
  SpringConfig,
} from 'react-spring';

export interface Props {
  isActive?: boolean,
  className?: string,
  onOpen?: () => void,
  onClose?: () => void,
}

const Dropdown:React.FC<Props> = ({
  isActive = false,
  className,
  children,
  onOpen = () => {},
  onClose = () => {},
}) => {
  const outerRef = React.useRef<HTMLDivElement>(null);
  const { height, ref: innerRef } = useResizeDetector<HTMLDivElement>();

  const config: SpringConfig = {
    damping: 1,
    frequency: 0.05,
  };

  const { springHeight } = useSpring({
    from: { springHeight: 0 },
    springHeight: isActive ? height : 0,
    onRest: () => {
      if (isActive) onOpen();
      else onClose();
    },
    config,
  });

  return (
    <DropdownOuter
      ref={outerRef}
      style={{ height: springHeight }}
      className={[
        className,
        isActive ? 'active' : 'inactive',
      ].join(' ')}
    >
      <Inner ref={innerRef}>
        {children}
      </Inner>
    </DropdownOuter>
  );
};
export default Dropdown;

const DropdownOuter = styled(animated.div)`
  height: 0;
  overflow: hidden;
  transition: height 0.3s;
`;
const Inner = styled.div``;
